<div class="h-full w-full flex flex-col min-h-0 overflow-hidden">
    <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
        <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
            <div class="border-y border-zinc-200 bg-zinc-50 p-2 flex justify-end flex-shrink-0">
                <div class="flex gap-1 bg-zinc-100 rounded p-0.5">
                    <button [ngClass]="{
                            'px-2 py-1 rounded text-xs h-6': true,
                            'bg-white text-zinc-900 shadow-md': viewMode() === 'unified',
                            'text-zinc-500': viewMode() !== 'unified'
                        }" (click)="onTabChange({ value: 'unified' })">
                        Unified
                    </button>
                    <button [ngClass]="{
                            'px-2 py-1 rounded text-xs h-6': true,
                            'bg-white text-zinc-900 shadow-md': viewMode() === 'split',
                            'text-zinc-500': viewMode() !== 'split'
                        }" (click)="onTabChange({ value: 'split' })">
                        Split
                    </button>
                </div>
            </div>

            <div class="flex-1 min-h-0 overflow-y-auto">
                @if (viewMode() === 'unified') {
                <!-- Unified Diff View -->
                <div class="bg-white font-mono text-sm">
                    <table class="w-full border-collapse">
                        <tbody>
                            @for (line of lineDiff(); track $index) {
                            <tr [ngClass]="{
                'hover:bg-zinc-50': true,
                'bg-red-50': line.type === 'removed',
                'bg-emerald-50': line.type === 'added'
              }">
                                <td
                                    class="w-10 text-right select-none py-0.5 pr-1 pl-4 text-xs text-zinc-500 border-r border-zinc-200">
                                    {{ line.lineNumber }}
                                </td>
                                <td class="pl-2 py-0.5 w-6 select-none">
                                    @if (line.type === 'removed') {
                                    <app-icon [type]="'minus'" [class]="'h-3.5 w-3.5 text-red-500'" [source]="'lucide'"
                                        [size]="'sm'"></app-icon>
                                    }
                                    @if (line.type === 'added') {
                                    <app-icon [type]="'plus'" [class]="'h-3.5 w-3.5 text-emerald-500'"
                                        [source]="'lucide'" [size]="'sm'"></app-icon>
                                    }
                                </td>
                                <td class="w-full px-3 py-0.5">
                                    <div class="overflow-x-auto max-w-full text-xs">
                                        @if (line.type === 'removed') {
                                        <span class="text-red-700">{{ line.oldLine
                                            }}</span>
                                        }
                                        @if (line.type === 'added') {
                                        <span class="text-emerald-700">{{
                                            line.newLine }}</span>
                                        }
                                        @if (line.type === 'unchanged') {
                                        <span class="text-zinc-700">{{ line.oldLine
                                            }}</span>
                                        }
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                }

                @if (viewMode() === 'split') {
                <!-- Split Diff View -->
                <div class="bg-white font-mono text-sm">
                    <table class="w-full border-collapse">
                        <thead>
                            <tr class="border-b border-zinc-200 text-xs">
                                <th class="p-2 text-left text-zinc-500 w-1/2">Removed
                                </th>
                                <th class="p-2 text-left text-zinc-500 w-1/2">Added
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (line of lineDiff(); track $index) {
                            <tr>
                                <td [ngClass]="{
                  'p-2 align-top': true,
                  'bg-red-50 text-red-700': line.type === 'removed',
                  'bg-zinc-100': line.oldLine === null
                }">
                                    @if (line.oldLine !== null) {
                                    <div class="flex">
                                        <div class="w-8 text-right pr-2 select-none text-xs text-zinc-500">
                                            {{ line.lineNumber }}
                                        </div>
                                        @if (line.type === 'removed') {
                                        <app-icon [type]="'minus'"
                                            [class]="'h-3.5 w-3.5 text-red-500 mt-0.5 mr-2 flex-shrink-0'"
                                            [source]="'lucide'" [size]="'sm'"></app-icon>
                                        }
                                        <div class="overflow-x-auto">
                                            <span class="break-all">{{ line.oldLine }}</span>
                                        </div>
                                    </div>
                                    }
                                </td>
                                <td [ngClass]="{
                  'p-2 align-top': true,
                  'bg-emerald-50 text-emerald-700': line.type === 'added',
                  'bg-zinc-100': line.newLine === null
                }">
                                    @if (line.newLine !== null) {
                                    <div class="flex">
                                        <div class="w-8 text-right pr-2 select-none text-xs text-zinc-500">
                                            {{ line.lineNumber }}
                                        </div>
                                        @if (line.type === 'added') {
                                        <app-icon [type]="'plus'"
                                            [class]="'h-3.5 w-3.5 text-emerald-500 mt-0.5 mr-2 flex-shrink-0'"
                                            [source]="'lucide'" [size]="'sm'"></app-icon>
                                        }
                                        <div class="overflow-x-auto">
                                            <span class="break-all">{{ line.newLine }}</span>
                                        </div>
                                    </div>
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                }
            </div>
        </div>
    </div>
</div>